(() => {
  const body = document.body;
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const menuClose = document.querySelector("[data-menu-close]");

  const setMenu = (isOpen) => {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle("is-open", isOpen);
    body.classList.toggle("is-menu-open", isOpen);
  };

  menuToggle?.addEventListener("click", () => setMenu(true));
  menuClose?.addEventListener("click", () => setMenu(false));
  mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenu(false));
  });

  document.querySelectorAll("[data-slider]").forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll(".hero-slide"));
    const dots = Array.from(slider.querySelectorAll("[data-slide-dot]"));
    let activeIndex = 0;

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === activeIndex);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle("is-active", dotIndex === activeIndex);
      });
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => showSlide(dotIndex));
    });

    if (slides.length > 1) {
      window.setInterval(() => showSlide(activeIndex + 1), 5600);
    }
  });

  document.querySelectorAll("[data-mega-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-mega-track]");
    const previousButton = carousel.querySelector("[data-mega-prev]");
    const nextButton = carousel.querySelector("[data-mega-next]");

    const updateButtons = () => {
      if (!track) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      previousButton?.classList.toggle("is-hidden", track.scrollLeft <= 2);
      nextButton?.classList.toggle("is-hidden", track.scrollLeft >= maxScroll - 2);
      carousel.classList.toggle("is-scrollable", maxScroll > 2);
    };

    const scrollByPage = (direction) => {
      if (!track) return;
      track.scrollBy({
        left: direction * Math.max(track.clientWidth * 0.8, 220),
        behavior: "smooth",
      });
    };

    previousButton?.addEventListener("click", () => scrollByPage(-1));
    nextButton?.addEventListener("click", () => scrollByPage(1));
    track?.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  });

  document.querySelectorAll("[data-recommend-tabs]").forEach((section) => {
    const tabs = Array.from(section.querySelectorAll("[data-recommend-tab]"));
    const panels = Array.from(section.querySelectorAll("[data-recommend-panel]"));
    const carousels = Array.from(section.querySelectorAll("[data-recommend-carousel]"));

    const updateCarouselButtons = (carousel) => {
      const track = carousel.querySelector("[data-recommend-track]");
      const previousButton = carousel.querySelector("[data-recommend-prev]");
      const nextButton = carousel.querySelector("[data-recommend-next]");
      if (!track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      previousButton?.classList.toggle("is-hidden", track.scrollLeft <= 2);
      nextButton?.classList.toggle("is-hidden", track.scrollLeft >= maxScroll - 2);
      carousel.classList.toggle("is-scrollable", maxScroll > 2);
    };

    const activateTab = (tabId) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.recommendTab === tabId;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", String(isActive));
      });

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.recommendPanel === tabId);
      });

      const activeCarousel = section.querySelector(`[data-recommend-panel="${tabId}"] [data-recommend-carousel]`);
      if (activeCarousel) updateCarouselButtons(activeCarousel);
    };

    tabs.forEach((tab) => {
      const tabId = tab.dataset.recommendTab;
      tab.addEventListener("mouseenter", () => activateTab(tabId));
      tab.addEventListener("focus", () => activateTab(tabId));

      if (tab.tagName === "BUTTON") {
        tab.addEventListener("click", () => activateTab(tabId));
      }
    });

    carousels.forEach((carousel) => {
      const track = carousel.querySelector("[data-recommend-track]");
      const previousButton = carousel.querySelector("[data-recommend-prev]");
      const nextButton = carousel.querySelector("[data-recommend-next]");

      const scrollByPage = (direction) => {
        if (!track) return;
        track.scrollBy({
          left: direction * Math.max(track.clientWidth * 0.86, 240),
          behavior: "smooth",
        });
      };

      previousButton?.addEventListener("click", () => scrollByPage(-1));
      nextButton?.addEventListener("click", () => scrollByPage(1));
      track?.addEventListener("scroll", () => updateCarouselButtons(carousel), { passive: true });
      updateCarouselButtons(carousel);
    });

    window.addEventListener("resize", () => {
      carousels.forEach(updateCarouselButtons);
    });
  });

  const wishlistKey = "crystalsByDavidWishlist";
  const wishlistIcon =
    '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 0 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z"></path></svg>';

  const getWishlist = () => {
    try {
      return JSON.parse(window.localStorage.getItem(wishlistKey) || "[]");
    } catch (error) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  };

  const getProductData = (card, button) => {
    const mediaLink = card.querySelector(".product-card__media");
    const titleLink = card.querySelector(".product-card__body h3 a");
    const image = card.querySelector(".product-card__media img");
    const title = button.dataset.wishlistTitle || titleLink?.textContent?.trim() || "Wishlist item";
    const url = button.dataset.wishlistUrl || titleLink?.href || mediaLink?.href || "/pages/wishlist";

    return {
      id: button.dataset.wishlistId || url || title,
      title,
      url,
      image: button.dataset.wishlistImage || image?.currentSrc || image?.src || "",
    };
  };

  document.querySelectorAll(".product-card").forEach((card) => {
    const media = card.querySelector(".product-card__media");
    if (!media) return;

    let frame = card.querySelector(".product-card__media-frame");
    if (!frame) {
      frame = document.createElement("div");
      frame.className = "product-card__media-frame";
      media.parentNode.insertBefore(frame, media);
      frame.appendChild(media);
    }

    if (!frame.querySelector(".product-card__wishlist")) {
      const wishlistButton = document.createElement("button");
      wishlistButton.className = "product-card__wishlist";
      wishlistButton.type = "button";
      wishlistButton.setAttribute("aria-label", "Add to wishlist");
      wishlistButton.dataset.wishlistAdd = "";
      wishlistButton.innerHTML = wishlistIcon;
      frame.appendChild(wishlistButton);
    }

    if (!frame.querySelector(".product-card__actions")) {
      const actionLink = document.createElement("a");
      actionLink.className = "product-card__action-button";
      actionLink.href = media.href || "#";
      actionLink.textContent = "QUICK VIEW";

      const actions = document.createElement("div");
      actions.className = "product-card__actions";
      actions.appendChild(actionLink);
      frame.appendChild(actions);
    }
  });

  document.querySelectorAll("[data-wishlist-add]").forEach((button) => {
    const card = button.closest(".product-card");
    if (!card) return;

    const updateState = () => {
      const item = getProductData(card, button);
      const isSaved = getWishlist().some((wishlistItem) => wishlistItem.id === item.id);
      button.classList.toggle("is-active", isSaved);
      button.setAttribute("aria-label", isSaved ? "Added to wishlist" : "Add to wishlist");
    };

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const item = getProductData(card, button);
      const items = getWishlist();
      if (!items.some((wishlistItem) => wishlistItem.id === item.id)) {
        items.push(item);
        saveWishlist(items);
      }
      updateState();
    });

    updateState();
  });

  document.querySelectorAll("[data-wishlist-page]").forEach((page) => {
    const grid = page.querySelector("[data-wishlist-grid]");
    const emptyState = page.querySelector("[data-wishlist-empty]");

    const renderWishlist = () => {
      const items = getWishlist();
      if (!grid || !emptyState) return;

      grid.innerHTML = "";
      emptyState.hidden = items.length > 0;

      items.forEach((item) => {
        const article = document.createElement("article");
        article.className = "wishlist-page__item product-card";

        const frame = document.createElement("div");
        frame.className = "product-card__media-frame";

        const mediaLink = document.createElement("a");
        mediaLink.className = "product-card__media";
        mediaLink.href = item.url || "#";
        mediaLink.setAttribute("aria-label", item.title || "Wishlist item");

        if (item.image) {
          const image = document.createElement("img");
          image.src = item.image;
          image.alt = item.title || "Wishlist item";
          image.loading = "lazy";
          image.width = 720;
          image.height = 900;
          mediaLink.appendChild(image);
        } else {
          const placeholder = document.createElement("span");
          placeholder.className = "product-card__placeholder";
          mediaLink.appendChild(placeholder);
        }

        const removeButton = document.createElement("button");
        removeButton.className = "wishlist-page__remove";
        removeButton.type = "button";
        removeButton.textContent = "Remove";
        removeButton.addEventListener("click", () => {
          saveWishlist(getWishlist().filter((wishlistItem) => wishlistItem.id !== item.id));
          renderWishlist();
        });

        const body = document.createElement("div");
        body.className = "product-card__body";

        const title = document.createElement("h3");
        const titleLink = document.createElement("a");
        titleLink.href = item.url || "#";
        titleLink.textContent = item.title || "Wishlist item";
        title.appendChild(titleLink);

        frame.appendChild(mediaLink);
        frame.appendChild(removeButton);
        body.appendChild(title);
        article.appendChild(frame);
        article.appendChild(body);
        grid.appendChild(article);
      });
    };

    renderWishlist();
  });

  document.querySelectorAll("[data-product-hover-gallery]").forEach((gallery) => {
    const images = Array.from(gallery.querySelectorAll("[data-hover-image], .product-card__image"));
    if (images.length <= 1) return;

    let activeIndex = Math.max(images.findIndex((image) => image.classList.contains("is-active")), 0);
    let intervalId;

    const showImage = (index) => {
      activeIndex = (index + images.length) % images.length;
      images.forEach((image, imageIndex) => {
        image.classList.toggle("is-active", imageIndex === activeIndex);
      });
    };

    const startGallery = () => {
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => showImage(activeIndex + 1), 850);
    };

    const stopGallery = () => {
      window.clearInterval(intervalId);
      showImage(0);
    };

    showImage(activeIndex);
    gallery.addEventListener("mouseenter", startGallery);
    gallery.addEventListener("mouseleave", stopGallery);
    gallery.addEventListener("focusin", startGallery);
    gallery.addEventListener("focusout", stopGallery);
  });

  const cartToast = document.querySelector("[data-cart-toast]");
  const cartToastTitle = cartToast?.querySelector("[data-cart-toast-title]");
  const cartToastImage = cartToast?.querySelector("[data-cart-toast-image]");
  const cartToastMedia = cartToast?.querySelector(".cart-toast__media");
  const cartToastClose = cartToast?.querySelector("[data-cart-toast-close]");
  let cartToastTimer;

  const hideCartToast = () => {
    if (!cartToast) return;
    cartToast.classList.remove("is-visible");
    window.setTimeout(() => {
      if (!cartToast.classList.contains("is-visible")) {
        cartToast.hidden = true;
      }
    }, 280);
  };

  const showCartToast = ({ title, image, status = "ADDED TO CART" }) => {
    if (!cartToast) return;

    if (cartToastTitle) {
      cartToastTitle.textContent = [title || "ITEM", status].filter(Boolean).join(" ");
    }

    if (cartToastImage && cartToastMedia) {
      if (image) {
        cartToastImage.src = image;
        cartToastImage.alt = title || "Added product";
        cartToastMedia.classList.remove("is-empty");
      } else {
        cartToastImage.removeAttribute("src");
        cartToastImage.alt = "";
        cartToastMedia.classList.add("is-empty");
      }
    }

    window.clearTimeout(cartToastTimer);
    cartToast.hidden = false;
    window.requestAnimationFrame(() => cartToast.classList.add("is-visible"));
    cartToastTimer = window.setTimeout(hideCartToast, 3500);
  };

  cartToastClose?.addEventListener("click", hideCartToast);

  const getCartToastDetails = (form, submitter, item = {}) => {
    const card = form.closest(".product-card");
    const productTitle =
      card?.querySelector(".product-card__body h3 a")?.textContent?.trim() ||
      form.closest(".main-product__summary")?.querySelector("h1")?.textContent?.trim() ||
      document.querySelector(".main-product__summary h1")?.textContent?.trim() ||
      item.product_title ||
      item.title ||
      "Item";
    const submitterText = submitter?.textContent?.replace(/\s+/g, " ").trim() || "";
    const variantTitle =
      item.variant_title && item.variant_title !== "Default Title"
        ? item.variant_title
        : submitterText && !/quick\s+(add|view)/i.test(submitterText)
          ? submitterText
          : "";
    const image =
      card?.querySelector(".product-card__image.is-active")?.currentSrc ||
      card?.querySelector(".product-card__media img")?.currentSrc ||
      document.querySelector(".main-product__image.is-active img")?.currentSrc ||
      item.image ||
      "";

    return {
      title: `${productTitle}${variantTitle ? ` ${variantTitle}` : ""}`.trim(),
      image,
    };
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll(".site-header__cart span").forEach((count) => {
        count.textContent = String(cart.item_count || 0);
      });
    } catch (error) {
      // Keep the add-to-cart flow quiet if cart count refresh fails.
    }
  };

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter?.disabled) return;

      const formData = new FormData(form);
      if (submitter?.name && submitter.value) {
        formData.set(submitter.name, submitter.value);
      }

      submitter?.setAttribute("aria-busy", "true");
      submitter?.setAttribute("disabled", "disabled");

      try {
        const addUrl = new URL(form.action, window.location.origin);
        addUrl.pathname = addUrl.pathname.replace(/\/cart\/add$/, "/cart/add.js");

        const response = await fetch(addUrl.toString(), {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        });

        const item = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(item.description || "Unable to add item to cart");
        }

        showCartToast(getCartToastDetails(form, submitter, item));
        updateCartCount();
      } catch (error) {
        showCartToast({ title: "UNABLE TO ADD ITEM", status: "PLEASE TRY AGAIN", image: "" });
      } finally {
        submitter?.removeAttribute("aria-busy");
        submitter?.removeAttribute("disabled");
      }
    });
  });

  document.querySelectorAll(".quantity-control").forEach((control) => {
    const input = control.querySelector("input");
    const minus = control.querySelector("[data-quantity-minus]");
    const plus = control.querySelector("[data-quantity-plus]");

    minus?.addEventListener("click", () => {
      const nextValue = Math.max(Number(input.value || 1) - 1, Number(input.min || 1));
      input.value = String(nextValue);
    });

    plus?.addEventListener("click", () => {
      input.value = String(Number(input.value || 1) + 1);
    });
  });

  document.querySelectorAll("[data-product-media]").forEach((button) => {
    button.addEventListener("click", () => {
      const gallery = button.closest(".main-product__gallery");
      gallery?.querySelectorAll("[data-product-media]").forEach((media) => {
        media.classList.toggle("is-active", media === button);
      });
    });
  });
})();
